import { Dispatch, useReducer } from "react";

import { FormState, SetFormState } from "../types";

type Action =
  | {
      type: "SET_VALUE";
      field: keyof FormState;
      value: FormState[keyof FormState];
    }
  | {
      type: "SET_VALUES";
      payload: Partial<FormState>;
    }
  | { type: "RESET" }
  | { type: "SET_STATE"; payload: FormState };

const initialState: FormState = {
  isApprovedQuote: false,
  isCompetitive: false,
  isPackageRatesApply: false,
  includeInMarketingPresentation: false,
  marketingTemplateExcludeReason: "",
  marketingTemplateExcludeOtherReason: "",
  requoteNeeded: false,
  requoteReason: "",
  requoteOtherReason: "",
};

const reducer = (state: FormState, action: Action): FormState => {
  switch (action.type) {
    case "SET_VALUE":
      return { ...state, [action.field]: action.value };
    case "SET_VALUES":
      return { ...state, ...action.payload };
    case "RESET":
      return initialState;
    case "SET_STATE":
      return action.payload;
    default:
      return state;
  }
};

function useFormState(): [FormState, SetFormState, Dispatch<Action>] {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setState = (
    field: keyof FormState | Partial<FormState>,
    value?: FormState[keyof FormState],
  ) => {
    if (typeof field === "object") {
      dispatch({ type: "SET_VALUES", payload: field });
    } else if (value !== undefined) {
      dispatch({ type: "SET_VALUE", field, value });
    }
  };

  return [state, setState, dispatch];
}

export default useFormState;
